const { createConstant } = require('../helpers')

const service = 'trustgate-service'

module.exports = {
  GET_CERTIFICATE_INFO: createConstant(service, 'GET_CERTIFICATE_INFO'),
  GET_CERTIFICATE_INFO_SUCCESS: createConstant(service, 'GET_CERTIFICATE_INFO_SUCCESS'),
  GET_CERTIFICATE_INFO_ERROR: createConstant(service, 'GET_CERTIFICATE_INFO_ERROR'),
  GET_CERTIFICATE_INFO_RESET: createConstant(service, 'GET_CERTIFICATE_INFO_RESET'),
}
